// extracted by mini-css-extract-plugin
module.exports = {"report":"report_report__3ceZD","form":"report_form__3TZ03","button":"report_button__2pMPL","content":"report_content__20Fg2","back_link":"report_back_link__2toXs"};